import * as THREE from 'three';
import { Weapon, WeaponConfig } from './Weapon';
import { Missile } from '../entities/Missile';

export class MissileWeapon extends Weapon {
  constructor() {
    const config: WeaponConfig = {
      name: '导弹',
      type: 'missile',
      damage: 60,
      cooldown: 2.0, // Long cooldown
      ammo: 10,
      maxAmmo: 10,
      projectileSpeed: 20,
      range: 80,
      areaOfEffect: 5 // 5 unit radius
    };
    super(config);
  }

  createProjectile(
    position: THREE.Vector3,
    direction: THREE.Vector3,
    owner: 'player' | 'enemy'
  ): Missile {
    return new Missile(position, direction, owner, this.config.damage, this.config.areaOfEffect!);
  }

  createProjectileWithTarget(
    position: THREE.Vector3,
    direction: THREE.Vector3,
    owner: 'player' | 'enemy',
    target?: THREE.Vector3
  ): Missile {
    return new Missile(position, direction, owner, this.config.damage, this.config.areaOfEffect!, target);
  }
}
